import { createApp } from 'vue';
import InstantSearch from 'vue-instantsearch/vue3/es';
import EntrySearchProduct from '@/components/entry/EntrySearchProduct.vue';
import { createPinia } from 'pinia';
import VueObserveVisibility from 'vue-observe-visibility';
import { useSessionStore } from '@/store/storeSession.js';

const app = createApp(EntrySearchProduct);
const pinia = createPinia();

app.provide('global_setTitleHeight', setTitleHeight);
app.provide('global_appId', globalAlgoliaId);
app.provide('global_apiKey', globalAlgoliaKey);
app.provide('global_appIdStag', globalAlgoliaIdStag);
app.provide('global_apiKeyStag', globalAlgoliaKeyStag);
app.provide('global_environment', globalEnvironment);
app.provide('global_index', globalAlgoliaIndex);
app.provide('global_indexStag', globalAlgoliaStagIndex);
app.provide('global_store', globalAlgoliaStore);
app.provide('global_isAvibe', globalIsAvibe);
app.provide('global_trackAlgolia', globalTrackAlgolia);
app.provide('global_imgix', globalImgix);
app.provide('global_userToken', globalUserToken);
app.provide('global_authUserToken', globalAuthUserToken);
app.provide('global_hasStore', globalHasStore);

app.use(InstantSearch);
app.use(pinia);
app.use(VueObserveVisibility);

const sessionStore = useSessionStore();
window.sessionStore = sessionStore;

app.mount('#app');
